export default __webpack_public_path__ + "static/media/0189.0f5d4950.jpg";